module.exports = __webpack_public_path__ + "aquax.525fab2.jpg";